// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Colors */
/****BRAND COLORS*****/
/****END BRAND COLORS*****/
/* Color Classes*/
/*#region*/
.blue.background {
  background: rgb(22, 109, 255) !important;
}
.blue.text {
  color: rgb(22, 109, 255) !important;
}

.green.background {
  background: rgb(124, 187, 46) !important;
}
.green.text {
  color: rgb(124, 187, 46) !important;
}

.gold.background {
  background: rgb(255, 189, 28) !important;
}
.gold.text {
  color: rgb(255, 189, 28) !important;
}

.orange.background {
  background: rgb(255, 132, 35) !important;
}
.orange.text {
  color: rgb(255, 132, 35) !important;
}

.red.background {
  background: rgb(255, 0, 0) !important;
}
.red.text {
  color: rgb(255, 0, 0) !important;
}

.pink.background {
  background: rgb(255, 47, 154) !important;
}
.pink.text {
  color: rgb(255, 47, 154) !important;
}

.purple.background {
  background: rgb(177, 0, 234) !important;
}
.purple.text {
  color: rgb(177, 0, 234) !important;
}

.cyan.background {
  background: rgb(48, 205, 155) !important;
}
.cyan.text {
  color: rgb(48, 205, 155) !important;
}

/*#endregion*/
/* Font */
/* Shadows */
/* Borders */
/* Transitions and Animations*/
/* Z Index */
.create_product_page .variant {
  display: inline-block;
  background: rgb(48, 205, 155);
  color: rgb(255, 255, 255);
  border-radius: 0px;
  box-shadow: rgba(50, 50, 50, 0.1) 2px 3px 10px;
  padding: 15px;
  margin: 0px;
}
.create_product_page .variant svg {
  display: inline-block;
  margin-left: 5px;
  color: rgb(255, 255, 255);
}
.create_product_page .delete {
  display: inline;
  width: 40px;
  margin-top: 5px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  opacity: 0.6;
}
.create_product_page .delete:hover {
  color: rgb(255, 0, 0);
  opacity: 0.8;
}
.create_product_page .variation_warning {
  color: rgba(0, 0, 0, 0.6);
}
.create_product_page .checkbox_wrapper {
  display: flex;
  max-width: 100px;
  flex-direction: column;
}
.create_product_page .checkbox_wrapper label {
  max-width: 100px;
}
.create_product_page .checkbox_wrapper input {
  width: 100%;
  min-width: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/products/edit-product/_editProduct.scss"],"names":[],"mappings":"AAGA,UAAA;AACA,sBAAA;AASA,0BAAA;AAoBA,iBAAA;AACA,UAAA;AAEI;EACI,wCAAA;AC9BR;ADgCI;EACI,mCAAA;AC9BR;;ADkCI;EACI,wCAAA;AC/BR;ADiCI;EACI,mCAAA;AC/BR;;ADmCI;EACI,wCAAA;AChCR;ADkCI;EACI,mCAAA;AChCR;;ADoCI;EACI,wCAAA;ACjCR;ADmCI;EACI,mCAAA;ACjCR;;ADqCI;EACI,qCAAA;AClCR;ADoCI;EACI,gCAAA;AClCR;;ADsCI;EACI,wCAAA;ACnCR;ADqCI;EACI,mCAAA;ACnCR;;ADuCI;EACI,uCAAA;ACpCR;ADsCI;EACI,kCAAA;ACpCR;;ADwCI;EACI,wCAAA;ACrCR;ADuCI;EACI,mCAAA;ACrCR;;ADwCA,aAAA;AAEA,SAAA;AAOA,YAAA;AAUA,YAAA;AAMA,8BAAA;AAIA,YAAA;AC7HI;EACI,qBAAA;EACA,6BDOD;ECNC,yBDeW;ECdX,kBDgHQ;EC/GR,8CDsGK;ECrGL,aAAA;EACA,WAAA;AAiER;AAhEQ;EACI,qBAAA;EACA,gBAAA;EACA,yBDOO;AC2DnB;AA/DI;EACI,eAAA;EACA,WAAA;EACA,eAAA;EACA,yBDDe;ECEf,eDoFU;ECnFV,YAAA;AAiER;AA/DQ;EACI,qBDjBN;ECkBM,YAAA;AAiEZ;AA7DI;EACI,yBDZe;AC2EvB;AA7DI;EACI,aAAA;EACA,gBAAA;EACA,sBAAA;AA+DR;AA9DQ;EACI,gBAAA;AAgEZ;AA9DQ;EACI,WAAA;EACA,yBAAA;AAgEZ","sourcesContent":["// @import './variables';\r\n// @import './common';\r\n\r\n/*Colors */\r\n/****BRAND COLORS*****/\r\n$blue: rgb(22,109,255);\r\n$green: rgb(124,187,46);\r\n$gold: rgb(255,189,28);\r\n$orange: rgb(255,132,35);;\r\n$red: rgb(255,0,0);\r\n$pink: rgb(255,47,154);\r\n$purple: rgb(177,0,234);\r\n$cyan: rgb(48,205,155);\r\n/****END BRAND COLORS*****/\r\n$color_gray: rgb(198, 198, 198);\r\n$color_undefined: rgb(198, 198, 198);\r\n$color_primary: rgb(22,109,255);\r\n$color_error: rgb(224, 70, 70);\r\n$color_disabled: rgba(30,30,30,.3);\r\n$text_color_dark: rgba(0,0,0,1);\r\n$text_color_dark_soft: rgba(0,0,0,.6); \r\n$text_color_light: rgba(255,255,255,1);\r\n$text_color_light_soft: rgba(255,255,255,.5);\r\n$border_color_primary: rgba(30,30,30,.2);\r\n$button_border_color_primary: rgba(31, 74, 193, 1);\r\n$placeholder_color: rgba(30,30,30,.2);\r\n$placeholder_color_hover: rgba(30,30,30,.5);\r\n$navigation_button_color_hover: rgba(194, 205, 238, 0.2);\r\n\r\n$background_color_primary: #fff;\r\n$background_color_secondary: rgb(253, 253, 253);\r\n\r\n\r\n/* Color Classes*/\r\n/*#region*/\r\n.blue {\r\n    &.background {\r\n        background: $blue !important;\r\n    }\r\n    &.text {\r\n        color: $blue !important;\r\n    }\r\n}\r\n.green {\r\n    &.background {\r\n        background: $green !important;\r\n    }\r\n    &.text {\r\n        color: $green !important;\r\n    }\r\n}\r\n.gold {\r\n    &.background {\r\n        background: $gold !important;\r\n    }\r\n    &.text {\r\n        color: $gold !important;\r\n    }\r\n}\r\n.orange {\r\n    &.background {\r\n        background: $orange !important; \r\n    }\r\n    &.text {\r\n        color: $orange !important;\r\n    }\r\n}\r\n.red {\r\n    &.background {\r\n        background: $red !important;\r\n    }\r\n    &.text {\r\n        color: $red !important;\r\n    }\r\n}\r\n.pink {\r\n    &.background {\r\n        background: $pink !important;\r\n    }\r\n    &.text {\r\n        color: $pink !important;\r\n    }\r\n}\r\n.purple {\r\n    &.background {\r\n        background: $purple !important;\r\n    }\r\n    &.text {\r\n        color: $purple !important;\r\n    }\r\n}\r\n.cyan {\r\n    &.background {\r\n        background: $cyan !important;\r\n    }\r\n    &.text {\r\n        color: $cyan !important;\r\n    }\r\n}\r\n/*#endregion*/\r\n\r\n/* Font */\r\n$font_size_button: 14px;\r\n$font_size_navigation: 16px;\r\n$font_size_standard: 14px;\r\n$font_size_subtitle: 24px;\r\n$font_size_small: 12px;\r\n\r\n/* Shadows */\r\n$soft_shadow: rgba(0, 0, 0, 0.2) 0px 24px 38px 3px;\r\n$row_shadow: rgba(50,50,50,.1) 2px 3px 10px;\r\n$row_shadow_hover: rgba(50,50,50,.15) 4px 5px 10px;\r\n$side_nav_shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;\r\n//$form_input_shadow: rgba(0, 0, 0, 0.1) 0px 10px 10px 0px; //original\r\n$form_input_shadow: rgba(30,30, 30, .1) 2px 2px 10px ;\r\n//$form_input_shadow_hover: rgba(0, 0, 0, 0.11) 2px 14px 10px 0px; //original\r\n$form_input_shadow_hover: rgba(30,30, 30, .15) 4px 4px 15px ;\r\n\r\n/* Borders */\r\n$border_radius: 0px;\r\n$border_button_radius: 0px;\r\n$border_active_width: 0px;\r\n$border_round: 20px;\r\n\r\n/* Transitions and Animations*/\r\n$transition_speed: 200ms;\r\n$animation_speed: 400ms; //currently used for fading in modal\r\n\r\n/* Z Index */\r\n$z_loader: 403;\r\n$z_modal_foreground: 402;\r\n$z_modal_background: 401;\r\n$z_sidecart: 97;\r\n$z_sidecart_background: 96;\r\n$z_select_dropdown: 94;\r\n$z_navbar: 95;","@import \"../../../styles/variables\";\r\n\r\n.create_product_page {\r\n    .variant {\r\n        display: inline-block;\r\n        background: $cyan;\r\n        color: $text_color_light;\r\n        border-radius: $border-radius;\r\n        box-shadow: $row_shadow;\r\n        padding: 15px;\r\n        margin: 0px;\r\n        svg {\r\n            display: inline-block;\r\n            margin-left: 5px;\r\n            color: $text_color_light;\r\n        }\r\n    }\r\n    .delete {\r\n        display: inline;\r\n        width: 40px;\r\n        margin-top: 5px;\r\n        color: $text_color_dark_soft;\r\n        font-size: $font_size_small;\r\n        opacity: .6;\r\n\r\n        &:hover {\r\n            color: $red;\r\n            opacity: .8;\r\n        }\r\n    }\r\n\r\n    .variation_warning {\r\n        color: $text_color_dark_soft;\r\n    }\r\n    .checkbox_wrapper {\r\n        display: flex;\r\n        max-width: 100px;\r\n        flex-direction: column;\r\n        label {\r\n            max-width: 100px;\r\n        }\r\n        input {\r\n            width: 100%;\r\n            min-width: 0px !important;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
